<template>
    <v-container>
      <v-row>
          <v-col cols="12">
            <div class="text-left" style="margin-bottom:20px;">
                <router-link to="/">
                    <v-btn
                        color="secondary"
                        class="text-right"
                        style="width:250px"
                    >
                        Back
                    </v-btn>
                </router-link>
              </div>                  
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h1>New Zealand</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:0px;">
            May 8, 2026, Sydney to Queenstown
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:20px;">
            May 9, 2026 - Milford Sound
          </div>
        </v-col>
      </v-row>      
      <div class="text-left">Queenstown to Sydney May 11, 2026</div>
      <div class="text-left">Arrive Sydney May 11, 2026</div>

    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'NewZealand',
    setup() {
    }
  }
  </script>

